
import React, { useState } from 'react'
import axiosInstance from './AxiosInstance';
import { useToast } from 'components/ui/ToastContainer';

function Useaxios() {
    const [loading, setLoading] = useState(false);
    const { showSuccess, showError } = useToast();
    // const { loading, setLoading } = useAuth();

    const fetchData = async ({ url, method = 'get', data = {}, params = {}, headers = {}, showLoader = true, showMessage = true }) => {
        setLoading(true)
        try {
            const res = await axiosInstance({
                url,
                method,
                data,
                params,
                headers
                // headers optional
            });
            if (showMessage) {
                showSuccess(res?.data?.message)
            }
            return res.data;

        } catch (error) {
  
            console.log(error)
            setLoading(false);
            showError(error.response?.data?.message || error.message)
            throw error;
        } finally {
            setLoading(false);
        }
    }
    return { fetchData, loading };
}

export default Useaxios